import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

class FlyingProbeTest extends Component {

    render() {
        return (
            <div className="container-fluid">
                <p>
                    1層・2層基板についてのフライング検査はオプション選択となります。
                </p>
                <p> ４層・6層基板については50枚までフライング検査が標準で実施されます。
                </p>
                <p> 50枚上の場合は、フライング検査費用が発生します。
                </p>

            </div>
        );
    }
}

export default FlyingProbeTest;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/FlyingProbeTest.js